import { useContext } from 'react';
import { AutosaveContext } from '../contexts/AutosaveContext';

const useAutosaveContext = () => {
  const context = useContext(AutosaveContext);

  if (!context) {
    throw new Error('useAutosaveContext must be used within a AutosaveContextProvider');
  }

  return context;
};

export default useAutosaveContext;
